import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'claimsMonitoringStatus'
})
export class ClaimsMonitoringStatusPipe implements PipeTransform {

  transform(value: any): any {

    if (value == "1") {
      return "Review required";
    }
    else if (value == "2") {
      return "Published";
    }
    else if (value == "3") {
      return "Client feedback";
    }
    else if (value == "4") {
      return "Error";
    }
    else {
      return "-";
    }
  }

}
